import React, { useState, useEffect } from "react";
import { api } from "../services/api";
import "./Reviews.css";

const FALLBACK_REVIEWS = [
  {
    id: 1,
    author_name: "Venkat Rao",
    author_title: "Total Knee Replacement Patient",
    rating: 5,
    review_text: "I had severe bilateral osteoarthritis in my knees for 6 years. Dr. Sunil Apsingi performed robotic total knee replacement. Today I am walking pain-free without any support. His surgical skill and polite explanation gave me utmost confidence.",
    owner_reply: "Thank you Mr. Venkat Rao. Wishing you a happy, active, and pain-free life ahead!",
    review_link: "https://g.co/kgs/medicover",
  },
  {
    id: 2,
    author_name: "Sneha Reddy",
    author_title: "Shoulder Arthroscopy & Rotator Cuff",
    rating: 5,
    review_text: "Suffered a rotator cuff tear during badminton tournament. Visited multiple doctors who suggested open surgery. Dr. Sunil performed minimally invasive keyhole arthroscopy. Within 3 months I regained full range of motion. Truly one of the best orthopedic surgeons in Hyderabad!",
    owner_reply: "Delighted to hear your sports recovery Sneha. Continue your shoulder conditioning exercises!",
    review_link: "https://g.co/kgs/medicover",
  },
  {
    id: 3,
    author_name: "Rajeshwar Goud",
    author_title: "ACL Reconstruction Patient",
    rating: 5,
    review_text: "Dr. Sunil Apsingi is a master in arthroscopy. Had an ACL tear and meniscus injury. The care taken before and after surgery was phenomenal. The nursing team and physiotherapy guidance at Medicover under his supervision were top notch.",
    owner_reply: "Glad to assist your rehabilitation Rajeshwar. Take care!",
    review_link: "https://g.co/kgs/medicover",
  },
];

const Reviews = () => {
  const [reviews, setReviews] = useState(FALLBACK_REVIEWS);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const data = await api.getReviews();
        if (data && data.length > 0) {
          setReviews(data);
        }
      } catch (err) {
        // Fallback already active
      }
    };
    fetchReviews();
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const current = reviews[currentIndex] || reviews[0];

  return (
    <section className="reviews-section section-padding">
      <div className="container">
        <div className="text-center mb-5">
          <span className="section-header-pill">
            <i className="fa-solid fa-star text-amber me-1"></i> Patient Testimonials
          </span>
          <h2 className="section-title-large">Real Recovery Stories</h2>
          <p className="section-subtitle-muted">
            Verified patient experiences from knee replacements, shoulder surgeries, and sports injury treatments.
          </p>
        </div>

        <div className="review-slider-wrapper">
          <div className="review-card-modern">
            <div className="review-card-header d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center gap-3">
                <div className="author-avatar-modern">
                  {current.author_name?.charAt(0) || "P"}
                </div>
                <div>
                  <h5 className="author-name-modern mb-0">{current.author_name}</h5>
                  <small className="text-teal font-monospace">{current.author_title || "Verified Patient"}</small>
                </div>
              </div>

              <div className="rating-stars d-flex gap-1">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`fa-solid fa-star ${i < (current.rating || 5) ? "star-filled" : "star-empty"}`}
                  ></i>
                ))}
              </div>
            </div>

            <p className="review-quote-text">
              "{current.review_text}"
            </p>

            {current.owner_reply && (
              <div className="doctor-response-card mt-4 p-3 rounded">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <i className="fa-solid fa-reply text-teal"></i>
                  <strong className="small text-navy">Dr. Sunil Apsingi's Response:</strong>
                </div>
                <p className="small mb-0 text-secondary">{current.owner_reply}</p>
              </div>
            )}

            {current.review_link && (
              <div className="mt-4 pt-3 border-top border-light d-flex justify-content-between align-items-center">
                <span className="text-muted small">
                  <i className="fa-brands fa-google text-teal me-1"></i> Verified Google Review
                </span>
                <a
                  href={current.review_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-medical-secondary text-sm py-1 px-3"
                >
                  View on Google <i className="fa-solid fa-arrow-up-right-from-square ms-1"></i>
                </a>
              </div>
            )}
          </div>

          {/* Slider Navigation Controls */}
          <div className="slider-controls-modern d-flex justify-content-center align-items-center gap-4 mt-4">
            <button
              type="button"
              className="slider-nav-btn"
              onClick={handlePrev}
              aria-label="Previous Review"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <div className="slider-dots d-flex gap-2">
              {reviews.slice(0, Math.min(reviews.length, 6)).map((_, idx) => (
                <button
                  key={idx}
                  type="button"
                  className={`dot-indicator ${idx === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(idx)}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>

            <button
              type="button"
              className="slider-nav-btn"
              onClick={handleNext}
              aria-label="Next Review"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
